import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export type OcrQuotaUiState = {
  acknowledgedAllowanceSignatures: string[]
}

const initialState: OcrQuotaUiState = {
  acknowledgedAllowanceSignatures: [],
}

export const ocrQuotaUiSlice = createSlice({
  name: 'ocrQuotaUiState',
  initialState,
  reducers: {
    acknowledgeQuotaModal: (state, action: PayloadAction<string>) => {
      if (!state.acknowledgedAllowanceSignatures.includes(action.payload)) state.acknowledgedAllowanceSignatures.push(action.payload)
    },
    clearAcknowledgements: () => initialState,
  },
})

export const OcrQuotaUiActions = ocrQuotaUiSlice.actions
export default ocrQuotaUiSlice.reducer
